import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const CandidateJobApplicationsPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect to the old applications page
    if (user?.role === 'CANDIDATE') {
      navigate('/candidate/applications', { replace: true });
    }
  }, [navigate, user]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p>Redirecting to applications...</p>
      </div>
    </div>
  );
};

export default CandidateJobApplicationsPage;